import React from 'react'
import bandMountain from '../images/NP/FullSizeRender.jpg'
import Album from '../components/Album'
import { Helmet } from 'react-helmet-async'
import { FaItunes, FaSpotify } from 'react-icons/fa'
import myLogo from '../images/NP/TNP-3000.jpg'

const Home = () => {
  return (
    <>
      <Helmet>
        <title>The Non-Prophets - Home</title>
        <meta name="description" content="The Non-Prophets music and merch." />
        <link rel="canonical" href="/home" />
      </Helmet>
      <div className="bg-slate-50 pt-20 md:pt-0">
        <div className="w-full h-[250px] sm:h-[350px] md:h-[400px] overflow-hidden">
          <img
            src={bandMountain}
            alt="The band performing."
            className="w-full h-full object-cover object-center sm:object-top"
          />
        </div>

        <div className="text-center">
          <h1 className="text-xl p-6 ">
            "We have all travelled long, wayward roads to arrive at the same
            place.” <br></br> <br></br>
            New album, <span className="italic font-bold">BACKSTAGE PASS</span>
            {', '}
            available now.
          </h1>

          <div className="flex justify-center items-center gap-6 p-3">
            <a
              href="https://open.spotify.com/album/2dZnUysh8JMfyNiBg6h1C9?si=-W-Ye05RToulX0s3ArzL3g&nd=1&dlsi=8a600af216054026"
              target="_blank"
            >
              <button className="flex items-center gap-2 rounded bg-indigo-200 text-cyan-600 font-bold py-2 px-4 tracking-widest lg:mb-4 hover:opacity-80 duration-500 shadow-xl">
                STREAM <span className="font-normal">//</span>
                <FaSpotify className="text-green-500 text-3xl cursor-pointer" />
              </button>
            </a>

            <a
              href="https://music.apple.com/us/album/backstage-pass/6773667824"
              target="_blank"
            >
              <button className="flex items-center gap-2 rounded bg-indigo-200 text-cyan-600 font-bold py-2 px-4 tracking-widest lg:mb-4 hover:opacity-80 duration-500 shadow-xl">
                STREAM <span className="font-normal">//</span>
                <FaItunes className="text-pink-600 text-3xl" />
              </button>
            </a>
          </div>
        </div>
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={myLogo}
              alt="The Non-Prophets Logo"
              style={{ width: '350px', height: 'auto' }}
            />
          </div>
        </div>

        <div className="justify-center flex p-6 pt-">
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/O7pCO00YhI8?si=IFwxTV6Jl6fYt6i6"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            className=" max-w-3xl"
          ></iframe>
        </div>

        {/* <div>
          <Album />
        </div> */}
      </div>
    </>
  )
}

export default Home
